import { Facet } from '../models/Facet';
import { KeyFacet } from '../models/KeyFacet';
import { IQueuedOperation } from '../store/reducers/operationMapReducer';

/**
 * Facet which marks on an item which KeyFacet is the preferred form to use for the item.
 * Operations will attempt to use the preferred key facet, if provided, falling
 * back to the key they originally started with, when delegating to addons for processing.
 *
 * Supply this facet to an item to ensure that the best addon is used to provide
 * information for a given item.
 */
export const preferredKeyFacetFacet: Facet<KeyFacet<{}>> = new Facet('preferredKeyFacet');

export const operationQueueOperationsFacet: Facet<IQueuedOperation<object, object>[]> = new Facet('operationQueueOperations');

export const operationQueueHandlerFacet: Facet<() => void> = new Facet('operationQueueHandler');
